module.exports = __webpack_public_path__ + "img/portraits_21_V.4ac5e2a4.webp";